import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import {
  BsCheck2Circle,
  BsClockHistory,
  BsArrowRightShort,
  BsRepeat,
} from "react-icons/bs";
import { extractDate } from "../../../Components/Functions/date.fun";
import performRequest from "../../../api/request";
import { Toast } from "../../../CustomComponent/toast";
import { CustomErrorResponse } from "../../../CustomComponent/custom_error_response";

const tableHead = [
  "Sr.",
  // "Priority",
  // "Status",
  "Name",
  // "Start Date",
  // "End Date",
  "Assign To",
  "Actions",
];

const TaskManagementTable = ({ data = [], currentPage, itemsPerPage }) => {
  const navigate = useNavigate();
  const [userData, setUserData] = useState();
  const goToView = (id) => {
    navigate(`/task-management/view/${id}`);
  };

  useEffect(() => {
    performRequest("GET", "/login/alllogin/")
      .then((res) => {
        if (res.status === 201) {
          setUserData(res.data?.leads);
        } else {
          Toast("error", "Error while Creating");
        }
      })
      .catch((err) => {
        CustomErrorResponse(err);
      });
  }, []);

  const getNameById = (id) => {
    if (!id || !userData) {
      return "N/A";
    }
    const user = userData.find((user) => user.id == id);
    return user ? user.userName : "N/A";
  };

  const priorityColors = {
    P1: "bg-red text-white",
    P2: "bg-yellow text-white",
    P3: "bg-green text-white",
  };

  return (
    <div className="table-responsive"
    style={{
      maxHeight: "600px",  // adjust height as needed
      overflowY: "auto",
     
    }}>
      <table className="table table-vcenter ">
        <thead>
          <tr>
            {tableHead?.map((item, index) => {
              return <th key={index}>{item}</th>;
            })}
          </tr>
        </thead>
        <tbody>
          {data?.map((item, index) => {
            const Index = (currentPage - 1) * itemsPerPage + index + 1;
            return (
              <tr
                key={item?.id}
                className={
                  item?.status === "completed"
                    ? "table-success"
                    : item?.priority === "P1"
                    ? "table-danger"
                    : item?.priority === "P2"
                    ? "table-warning"
                    : item?.priority === "P3"
                    ? "table-info"
                    : ""
                }
              >
                <td>{Index}</td>
                {/* <td>
                  {item?.priority && (
                    <span
                      className={`badge ${priorityColors[item.priority]}`}
                      style={{ padding: "7px" }}
                    >
                      {item.priority}
                    </span>
                  )}
                </td> */}
                {/* <td>
                  {item?.status === "pending" ? (
                    <span
                      className="badge bg-orange"
                      style={{ color: "white" }}
                    >
                      {item?.taskType == "one time" ? (
                        <BsClockHistory className="fs-2" />
                      ) : (
                        <BsRepeat className="fs-2" />
                      )}
                    </span>
                  ) : (
                    (
                      <span
                        className="badge bg-green"
                        style={{ color: "white" }}
                      >
                        <BsCheck2Circle className="fs-2" />
                      </span>
                    ) || "N/A"
                  )}
                </td> */}
                <td style={{ width: "30%" }}>
                  {item?.name || "N/A"} <br />{" "}
                  <span className="text-secondary">
                    {getNameById(item?.generatedBy)}
                  </span>
                  <br />{" "}
                  <span className="text-secondary">
                    {item?.startDate || extractDate(item?.createdAt)}
                  </span>{" "}
                  <span className="text-secondary">
                    {item?.deadline || item?.endDate || "N/A"}
                  </span>
                </td>
                {/* <td style={{ width: "10%" }}>
                  {item?.startDate || extractDate(item?.createdAt)}
                </td> */}
                {/* <td style={{ width: "10%" }}>
                  {item?.deadline || item?.endDate || "N/A"}
                </td> */}
                <td>{item?.assignTo || "N/A"}</td>

                <td>
                  <button
                    className="btn btn-sm px-3 btn-primary"
                    onClick={() => goToView(item.id)}
                  >
                    <BsArrowRightShort className="me-1" />
                    View
                  </button>
                </td>
              </tr>
            );
          })}
        </tbody>
      </table>
    </div>
  );
};

export default TaskManagementTable;
